import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'What if my baby screams when I put them down?',
  a: 'Then you start at 0% (presence only) and stop early. This is practice, not a battle. The Ladder is designed to build tolerance without the tears.'
}, {
  q: "What if my partner 'helps' but asks me 10 questions?",
  a: 'You’ll use the Partner One‑Pager + the “On Deck” system included in the guide so the help is real and requires zero management from you.'
}, {
  q: 'How fast will I feel better?',
  a: 'Most moms feel relief the first day just from the Reset Station + Day Map — because basic needs stop being optional and start being planned.'
}, {
  q: 'Is this sleep training?',
  a: "No. There is no 'crying it out' or rigid schedules. This is about managing your day and gently building independent sleep skills over time."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section data-id="element-8">
      <h2 className="font-serif text-3xl md:text-4xl text-brown mb-12 text-center" data-id="element-9">
        Common Questions
      </h2>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-10">
        {faqs.map((faq, i) => <div key={i} className="border border-brown/10 rounded-xl overflow-hidden bg-white" data-id="element-11">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-cream/50 transition-colors" data-id="element-12">
              <span className="font-serif text-lg text-brown font-medium pr-4" data-id="element-13">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-14" />
            </button>
            <AnimatePresence data-id="element-15">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-16">
                  <div className="p-6 pt-0 text-brown-light leading-relaxed border-t border-brown/5" data-id="element-17">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}